{
  "page": {
    "title": "Tableau de bord",
    "mobileNotice": {
      "title": "Utilisez un ordinateur",
      "body": "Le tableau de bord admin est optimisé pour les écrans de 768px et plus. Ouvrez Printway sur un ordinateur ou tournez votre tablette pour voir les indicateurs opérationnels."
    },
    "kpiError": "KPI indisponibles — nouvelle tentative.",
    "vendorActivityAria": "Performance des fournisseurs + activité"
  },
  "kpi": {
    "labels": {
      "total_merchants": "Total marchands",
      "active_orders": "Commandes actives",
      "gross_revenue": "Revenu brut",
      "cogs": "Coût des ventes (COGS)",
      "gross_margin": "Marge brute",
      "avg_vendor_rating": "Note moyenne fournisseur",
      "pending_topups": "Recharges en attente",
      "open_support_tickets": "Support ouvert",
      "sync_errors_24h": "Erreurs de sync 24h",
      "order_warnings": "Alertes commandes",
      "new_blueprints": "Nouveaux blueprints",
      "outstanding_invoices": "Factures impayées"
    },
    "newBlueprintsBreakdown": "En attente {{pending}} · Rejetés {{rejected}} · Approuvés {{approved}} · Taux {{rate}}",
    "gridAria": "KPI du tableau de bord"
  },
  "quickActions": {
    "srHeading": "Actions rapides",
    "pendingAria": "{{count}} en attente",
    "reviewKyc": "Vérifier KYC",
    "reviewTopups": "Vérifier recharges",
    "assignOrders": "Affecter commandes",
    "supportInbox": "Boîte de support",
    "syncErrors": "Erreurs de sync",
    "reviewBlueprints": "Vérifier blueprints"
  },
  "alerts": {
    "srHeading": "Alertes opérationnelles",
    "unavailable": "Alertes indisponibles — nouvelle tentative.",
    "detail": "Détail",
    "viewAll": "Tout voir ({{total}})",
    "categoryAria": "Catégorie {{category}}",
    "categories": {
      "sla": "SLA",
      "capacity": "Capacité",
      "sync": "Synchronisation"
    }
  },
  "activity": {
    "heading": "Activité récente",
    "refreshing": "Actualisation…",
    "loadError": "Impossible de charger le flux d'activité.",
    "empty": "Aucune activité récente.",
    "loadOlderError": "Impossible de charger les activités plus anciennes.",
    "loading": "Chargement…",
    "loadOlder": "Charger plus ancien",
    "end": "Plus d'activité ancienne.",
    "entries": "{{count}} entrées",
    "types": {
      "new_merchant": "Inscription d'un nouveau marchand",
      "large_order_500": "Grosse commande (≥$500)",
      "sla_breach": "Violation du SLA",
      "sync_error": "Erreur de synchronisation",
      "topup_approval": "Approbation de recharge",
      "vendor_rating_change": "Changement de note fournisseur",
      "impersonation_event": "Événement d'usurpation"
    },
    "severity": {
      "info": "Info",
      "warning": "Avertissement",
      "critical": "Critique"
    },
    "relative": {
      "justNow": "à l'instant",
      "minutes": "il y a {{n}} min",
      "hours": "il y a {{n}} h",
      "days": "il y a {{n}} j"
    }
  },
  "charts": {
    "gridAria": "Graphiques du tableau de bord",
    "loadFailed": "Échec du chargement du graphique.",
    "revenue": {
      "title": "Tendance du revenu",
      "subtitle": "Revenu quotidien (USD canonique,)"
    },
    "orderVolume": {
      "title": "Volume de commandes",
      "subtitle": "Comptes quotidiens empilés par statut"
    },
    "utilization": {
      "title": "Utilisation des fournisseurs",
      "subtitle": "Top 10 fournisseurs × 30 jours"
    },
    "statusMix": {
      "title": "Répartition des statuts de commande",
      "subtitle": "Répartition actuelle par statut"
    },
    "topMerchants": {
      "title": "Top marchands par GMV",
      "subtitle": "Cliquez sur une barre pour ouvrir la page marchand"
    },
    "simple": {
      "loading": "Chargement des données…",
      "error": "Impossible de charger le graphique",
      "empty": "Aucune donnée sur cette période",
      "revenue": {
        "title": "Revenu",
        "subtitle": "USD par jour"
      },
      "orders": {
        "title": "Volume de commandes",
        "subtitle": "Commandes créées par jour"
      },
      "utilization": {
        "title": "Taux d'utilisation des fournisseurs",
        "subtitle": "Utilisation moyenne (%) par jour"
      },
      "status": {
        "title": "Répartition des statuts de commande",
        "subtitle": "Total des commandes par statut"
      }
    }
  },
  "revenueChart": {
    "loadingAria": "Chargement du graphique de tendance du revenu",
    "figureAria": "Graphique linéaire de tendance du revenu, 30 derniers jours, USD",
    "empty": "Aucune donnée de revenu pour la période sélectionnée."
  },
  "orderVolumeChart": {
    "loadingAria": "Chargement du graphique de volume de commandes",
    "figureAria": "Graphique de volume de commandes, comptes quotidiens empilés par statut",
    "empty": "Aucune donnée de volume de commandes pour la période sélectionnée.",
    "series": {
      "pending": "En attente",
      "in_progress": "En cours",
      "shipped": "Expédié",
      "cancelled": "Annulé"
    }
  },
  "orderStatusChart": {
    "loadingAria": "Chargement de la répartition des statuts de commande",
    "figureAria": "Graphique en anneau de répartition des statuts de commande",
    "empty": "Aucune donnée de statut de commande disponible.",
    "total": "Total"
  },
  "topMerchantsChart": {
    "loadingAria": "Chargement du graphique des top marchands par GMV",
    "figureAria": "Graphique à barres horizontales des top marchands par GMV",
    "empty": "Aucune donnée GMV marchand pour la période sélectionnée."
  },
  "utilizationChart": {
    "loadingAria": "Chargement de la heatmap d'utilisation des fournisseurs",
    "figureAria": "Heatmap d'utilisation des fournisseurs, top 10 fournisseurs sur 30 jours",
    "empty": "Aucune donnée d'utilisation des fournisseurs pour la période sélectionnée.",
    "day": "Jour {{n}}"
  },
  "dateRange": {
    "presetsAria": "Préréglages de période",
    "from": "Du",
    "to": "Au",
    "apply": "Appliquer",
    "presets": {
      "today": "Aujourd'hui",
      "last_7d": "7 derniers jours",
      "last_30d": "30 derniers jours",
      "this_month": "Ce mois-ci",
      "last_month": "Le mois dernier",
      "custom": "Personnalisé"
    }
  },
  "vendorTable": {
    "heading": "Performance des fournisseurs",
    "tabsAria": "Onglets de performance des fournisseurs",
    "tabTop": "Meilleurs fournisseurs",
    "tabIssues": "Fournisseurs à problèmes",
    "loadError": "Impossible de charger la performance des fournisseurs.",
    "emptyTop": "Aucun fournisseur n'atteint encore le seuil de performance.",
    "emptyIssues": "Aucun fournisseur n'est actuellement signalé pour des problèmes.",
    "columns": {
      "vendor": "Fournisseur",
      "rating": "Note",
      "orders": "Commandes",
      "backOrderRate": "Taux de rupture",
      "utilization": "Utilisation",
      "atRiskFlags": "Indicateurs à risque",
      "actions": "Actions"
    },
    "view": "Voir",
    "resolve": "Résoudre"
  },
  "widgetGrid": {
    "title": "Tableau de bord",
    "saving": "Enregistrement…",
    "addWidget": "+ Ajouter un widget",
    "resetDefault": "Réinitialiser par défaut",
    "loadError": "Impossible de charger la disposition du tableau de bord.",
    "rangeErrorCurrent": "La disposition doit contenir {{min}}-{{max}} widgets (actuellement {{count}}).",
    "rangeError": "La disposition doit contenir {{min}}-{{max}} widgets.",
    "resetConfirmTitle": "Réinitialiser le tableau de bord par défaut ?",
    "resetConfirmDesc": "Votre disposition de widgets personnalisée sera remplacée par la disposition par défaut de votre rôle. Cette action est irréversible.",
    "resetConfirm": "Réinitialiser",
    "cancel": "Annuler"
  },
  "widgetPicker": {
    "title": "Ajouter ou retirer des widgets du tableau de bord",
    "description": "Sélectionnez entre {{min}} et {{max}} widgets. La disposition est enregistrée automatiquement lorsque vous cliquez sur Appliquer.",
    "empty": "Aucun widget disponible pour votre rôle.",
    "tooFew": "Sélectionnez au moins {{min}} widgets (actuellement {{count}}).",
    "tooMany": "Sélectionnez au plus {{max}} widgets (actuellement {{count}}).",
    "selected": "{{count}} sur {{max}} widgets sélectionnés.",
    "cancel": "Annuler",
    "apply": "Appliquer",
    "categories": {
      "kpi": "KPI",
      "chart": "Graphiques",
      "table": "Tableaux",
      "feed": "Flux",
      "other": "Autre"
    }
  }
}
